import axios from 'axios';
const EnvConstants = require("../../EnvConstants");

export const api = async function(endpoint, type, data, configSecret = false){
    //const domain = process.env.W2ADOMAIN;
    const domain = EnvConstants.config.W2ADOMAIN;
    // const domain = "http://localhost:8080/";
    
    let headers = {};
    //headers.wpnativeappsrequestkey = process.env.WPNAREQUEST;
    headers.wpnativeappsrequestkey = EnvConstants.config.WPNAREQUEST;
    if(configSecret){
        headers.wpnativeappsid = configSecret.wpnativeappsid,
        headers.wpnativeappssecret = configSecret.wpnativeappssecret
    }
    try{
        let request = await axios({
            method: type,
            url: domain+endpoint,
            headers: headers,
            data: data
        });
        return request;
    } catch (error){
        console.log("Domain: ", domain);
        console.log("Endpoint: ", endpoint);
        console.log("API Error: ", error);
        return error.response;
    }
}